module.exports = __webpack_public_path__ + "static/media/Roldn-Logistics.e4476f19.png";